/*
 *
 * MyAccount constants
 *
 */

export const GET_USER_WATCHER = "app/MyAccount/GET_USER_WATCHER"
export const GET_USER_SUCCESS = "app/MyAccount/GET_USER_SUCCESS"
export const GET_USER_FAILED = "app/MyAccount/GET_USER_FAILED"
export const GET_LANGUAGE_WATCHER = "app/MyAccount/GET_LANGUAGE_WATCHER"
export const GET_LANGUAGE_SUCCESS = "app/MyAccount/GET_LANGUAGE_SUCCESS"
export const GET_LANGUAGE_FAILED = "app/MyAccount/GET_LANGUAGE_FAILED"

export const PUT_USER_WATCHER = "app/MyAccount/PUT_USER_WATCHER"
export const PUT_USER_SUCCESS = "app/MyAccount/PUT_USER_SUCCESS"
export const PUT_USER_FAILED = "app/MyAccount/PUT_USER_FAILED"
export const PUT_LANGUAGE_WATCHER = "app/MyAccount/PUT_LANGUAGE_WATCHER"
export const PUT_LANGUAGE_SUCCESS = "app/MyAccount/PUT_LANGUAGE_SUCCESS"
export const PUT_LANGUAGE_FAILED = "app/MyAccount/PUT_LANGUAGE_FAILED"

export const PASSWORD_USER_WATCHER = "app/MyAccount/PASSWORD_USER_WATCHER"
export const PASSWORD_USER_SUCCESS = "app/MyAccount/PASSWORD_USER_SUCCESS"
export const PASSWORD_USER_FAILED = "app/MyAccount/PASSWORD_USER_FAILED"
